import React, { Component } from 'react'
import styled from 'styled-components'
import { Button, Card, Colors, Modal, Tabs as OriginalTabs } from 'advenio-components'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import HomeReportModal from '../../Components/ParentPlatform/HomeReport/'
import RatingModal from '../../Components/ParentPlatform/RatingModal'
import MedicineModal from '../../Components/ParentPlatform/MedicineModal'
import PaymentModal from '../../Components/ParentPlatform/PaymentModal'
import CardsView from '../../Components/ParentPlatform/CardsView'
import Notifications from '../../Components/ProfileViews/Notifications'
import Reservations from '../../Components/ParentPlatform/Reservations'
import ReservationB2B from '../ReservationB2B'

import ProfilePanel from '../../Components/ParentPlatform/ProfilePanel'
import RecentActivity from '../../Components/ParentPlatform/RecentActivity'
import Profile from './Profile'
import Photos from './Photos'
import Balance from './Balance'
import Invoices from './Invoices'
import { TABS_STUDENT_PROFILE } from '../../Constants'

import ChildrenActions, { Selectors } from '../../Data/Redux/ParentPlatform/ChildrenRedux'
import ActivityActions from '../../Data/Redux/ActivityRedux'
import RatingActions from '../../Data/Redux/ParentPlatform/RatingRedux'
import MedicineActions from '../../Data/Redux/ParentPlatform/MedicineRedux'
import CenterActions from '../../Data/Redux/CenterRedux'
import ClassroomActions from '../../Data/Redux/ClassroomRedux'
import {empty, isEmpty, isNil, view} from 'ramda'
import moment from 'moment'

import { ProfilePictureContent, ProfileIcon } from '../../Components/ProfilePanel/ProfilePanel.styles'

const Page = styled.div`
`
const DesktopContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px;
  @media (max-width:768px) {
    padding: 0;
  }
`
const BalanceContainer = styled.div`
  display: block;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media (max-width:767px) {
    width: 100%;
    justify-content: center;
    padding: 8px;
    background: ${Colors.advenioRed};
  }
`
const BalanceCard = styled(Card)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  width: 300px;
  margin: 0;
  padding: 16px;
  font-size: 20px;
  float: right;

  @media (max-width:767px) {
    height: 100%;
    width: 100%;
  }
`
const Info = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
`
const TabList = styled(OriginalTabs)`
`
const PageContainer = styled(Card)`
  display: flex;
  flex-direction: column;
`
const ProfilePicture = styled.div`
  height: 100px;
  width: 200px;
  border-radius: 4px;
  background-color: ${Colors.red600};
  background-image: ${({profile}) => profile ? `url(${profile})` : ''};
  background-size: cover;
  background-position: center;
`

const views = (activeChild, disableAddHomeReport = null,toggleMedicine = null ,medicines = null ,child = {}, disabled = [], user = null) =>{
  const views = {
    tabs:[
        {
          title: TABS_STUDENT_PROFILE.activities,
        },
        {
          title: TABS_STUDENT_PROFILE.profile,
        },
        {
          title: TABS_STUDENT_PROFILE.gallery,
        },
        {
          title: TABS_STUDENT_PROFILE.balance,
        },
        {
          title: TABS_STUDENT_PROFILE.cards,
        },
        {
          title: TABS_STUDENT_PROFILE.notification,
        },
        {
          title: TABS_STUDENT_PROFILE.invoices,
        },
    ],
    views:[
        <RecentActivity
          parent
          onCheckIn={() => this.toggleHomeReportModal()}
          disableAddHomeReport={disableAddHomeReport}
          isDisenrolled={!! activeChild.deleted_at}
        />,
        <Profile
          onAddMedicineClick={toggleMedicine}
          child={activeChild}
          medicines={medicines}
          isDisenrolled={!! activeChild.deleted_at}
        />,
        <Photos />,
        <Balance />,
        <CardsView
          student={child}
          isDisenrolled={!! activeChild.deleted_at}

        />,
        <Notifications
          disabledNotifications={disabled}
          id={activeChild.id}
          parent
          isDisenrolled={!! activeChild.deleted_at}
        />,
        <Invoices
          studentId={activeChild.id}
        />
      ]
    }
  //TODO: section to reservation B2b fix reservation limit by day
  // if(!isEmpty(activeChild) && !isEmpty(activeChild.parents_with_contracts) && !isNil(activeChild.contract.contract_id)){
  //     views.tabs.push({title:'Reservaciones B2B'})
  //     views.views.push(<ReservationB2B parent={user} student={activeChild}/>)
  // }

  //TODO: is section to reservation Banamex when strategy back is deploy
  // descomment to producction
  // if(activeChild.contract !== undefined && activeChild.contract !== null ){
  //   if(activeChild.contract.company === 'CitiBanamex'){
  //     views.tabs.push({title:'Reservaciones'})
  //     if(activeChild.credit_cards.authorized < 1){
  //       views.views.push(<div style={{ marginLeft:"10px" }}><p>Debes de tener al menos una Tarjeta Autorizada.</p></div>)
  //     }
  //     else{
  //       if(window.screen.width < 768){
  //         views.views.push(<div style={{ marginLeft:"10px" }}><p>Accede desde un computadora.</p></div>)
  //       }
  //       else{
  //         views.views.push(<Reservations activeChildren = {activeChild} user = {user}/>)
  //       }
  //     }
  //   }
  // }
  return views
}
class Parent extends Component {
  state = {
    openHomeReportModal: false,
    openRating: false,
    openMedicine: false,
    openPayModal: false,
    isSmallDevice: false,
    child: null,
    disabled: [],
    disableAddHomeReport: false,
  }

  componentDidMount = () => {
    //window.addEventListener('resize', this.resize_width_callback);
    // window.removeEventListener('resize', this.resize_width_callback);
    this.resize_width_callback()

    this.props.getActivityCategories()
    this.props.getRating(0)
  }
  componentWillReceiveProps = (nextProps) => {
    const { errorRating, postRatingResponse,
      activeChildId, activeChild, rating, children,loadingRating } = nextProps
    if (errorRating !== null && errorRating.status === 404 && postRatingResponse.status !== 201) {
      this.setState({ openRating: true })
    }
    if (activeChildId !== this.props.activeChildId) {
      this.props.getMedicines(activeChildId)
      this.props.getCentersbyContract(activeChild.contract.contract_id)
      if (activeChild.disabled_notifications.length > 0) {
        const disabled = []
        for (let i = 0; i < activeChild.disabled_notifications.length; i += 1) {
          disabled.push(activeChild.disabled_notifications[i].id)
        }
        this.setState({ disabled })
      }
      this.setState({ child: activeChild })
    }
    if (children !== this.props.children) {
      const child = children.find(ch => ch.id === activeChildId)
      if (child) {
        if (child.disabled_notifications.length > 0) {
          const disabled = []
          for (let i = 0; i < child.disabled_notifications.length; i += 1) {
            disabled.push(child.disabled_notifications[i].id)
          }
          this.setState({ disabled })
        }
        this.setState({ child })
      }
    }
    if (rating.length > 0 && activeChild) {
      let rated = 0
      for (let i = 0; i < rating.length; i += 1) {
        if(rating[i].ratingable_type === 'Center'){
          if (rating[i].ratingable_id === activeChild.center.id) {
            rated += 1
          }
        }
      }
      if (rated === 0) {
        this.setState({ openRating: true })
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize_width_callback);
  }

  resize_width_callback = () => {
    this.setState({
      isSmallDevice: document.documentElement.clientWidth < 768,
    })
  }

  toggleHomeReportModal = () => {
    this.setState({
      openHomeReportModal: !this.state.openHomeReportModal,
      isSmallDevice: window.matchMedia('(max-width: 768px)').matches,
    })
  }

  toggleRating = () => this.setState({ openRating: !this.state.openRating })

  closeRating = () => this.setState({ openRating: false })

  toggleMedicine = () => this.setState({ openMedicine: !this.state.openMedicine })

  openPayModal = () => this.setState({ openPayModal: !this.state.openPayModal })

  disableOnAddHomeReport = () => this.setState({ disableAddHomeReport: true })
  onDrop = () => {
    const { activeChild, updateStudent } = this.props
    const [fileInput] = document.getElementsByName('profile');
    const file = fileInput.files[0]
    let payload = {}

    if (file) {

      const fileReader = new FileReader();

      fileReader.addEventListener("load", ({ target: { result } }) => {

        payload = {
          ...payload,
          profile_pic: result
        }

        updateStudent(activeChild.id, payload, activeChild.updated_at)

      });

      fileReader.readAsDataURL(file);
    }
  };
  render() {
    const {
      activeAccount,
      activeChild,
      activeChildId,
      activityCategories,
      hasRated,
      loading,
      loadingMedicine,
      medicines,
      sendingRating,
      submitRating,
      user,
    } = this.props
    const {
      child,
      isSmallDevice,
      openHomeReportModal,
      openMedicine,
      openRating,
      disableAddHomeReport,
      disabled,
    } = this.state
    return (
      <Page>
        {(!loading && activityCategories.length > 0) && activeChild !== null && activeChild !== undefined && !isEmpty(child)?
          <div>
            <DesktopContainer>
              {isSmallDevice && <ProfilePanel student={activeChild} onDrop={this.onDrop}/>}
              <BalanceContainer>
                {!isSmallDevice && <ProfilePictureContent style={{ float: 'left'}}>
                  <div
                    onClick={() => {
                      var [input] = document.getElementsByName('profile');
                      input.click();
                    }}>
                    <ProfilePicture
                      profile={
                        activeChild.profile_pictures &&
                        activeChild.profile_pictures["original"]
                      }

                    />
                    <ProfileIcon style={{ marginTop:-27, marginLeft:172, height:20, width:26}}>
                      <img src="/assets/camara.svg" alt="upload camera" style={{ width: 27, marginTop: -1, marginLeft: -1 }}/>
                    </ProfileIcon>
                    <input type="file" name='profile' style={{ display: "none", width:33, marginTop: -4, marginLeft: -3 }} accept="image/*" onChange={this.onDrop} />
                  </div>
                </ProfilePictureContent>}
                <BalanceCard>
                  <Info>
                    <span>Balance</span>
                    <span style={{ marginTop: '5px' }}>
                      {child && `${child.currency.symbol} ${child.outstanding_balance} ${child.currency.code}`}
                    </span>
                  </Info>
                  {user.country_id === 1 ? <Button primary onClick={this.openPayModal}>Pagar</Button>:''}
                </BalanceCard>
              </BalanceContainer>
              <PageContainer>
                <TabList
                  tabs={ views(activeChild).tabs }
                  content={ views(activeChild, disableAddHomeReport, this.toggleMedicine, medicines, child, disabled, user).views }
                  activeTab={activeAccount ? 'Tarjetas' : null}
                />
                <HomeReportModal
                  open={openHomeReportModal}
                  onClose={this.toggleHomeReportModal}
                  studentId={activeChild.id}
                  full={isSmallDevice}
                  onAddHomeReport={() => this.disableOnAddHomeReport()}
                />
                  {/* // descomment to producction */}
                <RatingModal
                  open={
                    openRating && !hasRated &&
                    activeChild.latest_health_check &&
                    ('created_at' in activeChild.latest_health_check) &&
                    moment().format('Y-M-D') === moment(activeChild.latest_health_check.created_at).format('Y-M-D') &&
                    activeChild.checkin.status=== 'Inactive'
                  }
                  onClose={this.closeRating}
                  submit={submitRating}
                  loading={sendingRating}
                  child={activeChild}
                />
              </PageContainer>
            </DesktopContainer>
          </div>
          :
          <Modal isOpened loading />
        }
        <Modal
          isOpened={this.state.openPayModal}
          headerTitle="Pago con tarjeta"
          onClose={this.openPayModal}
          full={isSmallDevice}
          statePath="parent_platform_payments"
          actionType="sending"
          typePrefix="PARENT_PLATFORM_PAYMENTS"
        >
          <PaymentModal
            cards={child && child.credit_cards}
            child={child}
            onClose={this.openPayModal}
          />
        </Modal>
        <MedicineModal
          onClose={this.toggleMedicine}
          open={openMedicine}
          createMedicine={this.props.createMedicine}
          studentId={activeChildId}
          loading={loadingMedicine}
        />
      </Page>
    )
  }
}

Parent.propTypes = {
  submitRating: PropTypes.func.isRequired,
  sendingRating: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  activityCategories: PropTypes.array.isRequired,
  hasRated: PropTypes.bool.isRequired,
  activeChildId: PropTypes.number,
  loadingMedicine: PropTypes.bool.isRequired,
  activeAccount: PropTypes.bool,
  medicines: PropTypes.array.isRequired,
  setAlreadyRated: PropTypes.func.isRequired,
  createMedicine: PropTypes.func.isRequired,
  getActivityCategories: PropTypes.func.isRequired,
  getRating: PropTypes.func.isRequired,
  getMedicines: PropTypes.func.isRequired,
}

Parent.defaultProps = {
  loading: false,
  activeChildId: 0,
  activeAccount: false,
}

const mapStateToProps = state => ({
  loading:
    state.activity.get.fetching ||
    state.parent_platform_rating.get.fetching||
    /** This line was commented because it causes a re-rendering bug if the recent activities list cannot be loaded */
    // state.parent_platform_children.get.fetching ||
    state.parent_platform_children.activeChildId === null,
  activityCategories: state.activity.get.results,
  activeChildId: state.parent_platform_children.activeChildId,
  activeChild: Selectors.activeChild(state) && Selectors.activeChild(state).student,
  rating: state.parent_platform_rating.get.results,
  children: state.parent_platform_children.get.results,
  hasRated: state.parent_platform_rating.hasRated,
  loadingRating: state.parent_platform_rating.get.fetching,
  sendingRating: state.parent_platform_rating.rating.fetching,
  errorRating: state.parent_platform_rating.get.error,
  postRatingResponse: state.parent_platform_rating.rating.result,
  loadingMedicine: state.parent_platform_medicine.medicine.fetching,
  medicines: state.parent_platform_medicine.get.results,
  activeAccount: state.unvalidatedReceipts.toProfile,
  user: state.auth.user,
})


const mapDispatchToProps = dispatch => ({
  getProfile: childId => dispatch(ChildrenActions.getProfileRequest(childId)),
  getActivityCategories: () => dispatch(ActivityActions.getRequest()),
  getRating: studentId => dispatch(RatingActions.getRequest(studentId)),
  getCentersbyContract: ContractId => dispatch(CenterActions.getCentersByContractRequest(ContractId)),
  submitRating: ratingInfo => dispatch(RatingActions.submitRatingRequest(ratingInfo)),
  setAlreadyRated: rate => dispatch(RatingActions.setAlreadyRated(rate)),
  createMedicine: medicine =>
    dispatch(MedicineActions.createMedicineRequest(medicine)),
  getMedicines: student_id => dispatch(MedicineActions.getRequest({ student_id }, true)),
  updateStudent: (activeParentId, profile, timestamp) =>
    dispatch(ChildrenActions.updateStudentRequest(activeParentId, profile, timestamp)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Parent)



// WEBPACK FOOTER //
// ./src/Containers/ParentPlatform/index.jsx